module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('progress-bar', {
    attrs: {
      "show": _vm.busy
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "grey lighten-4",
    attrs: {
      "primary-title": ""
    }
  }, [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(_vm.$t('settings')))])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "icons-and-text": "",
      "centered": "",
      "fixed": ""
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "primary"
    }
  }), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#tab-password"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('password')) + "\n          "), _c('v-icon', [_vm._v("lock")])], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "value": "tab-password"
    }
  }, [_c('password-view', {
    on: {
      "busy": function($event) {
        _vm.busy = $event
      }
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bacac8fe","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/index.vue
// module id = Q8zE
// module chunks = 1